import { Empty } from 'antd';
import React from 'react';
import { ORDER_STATUS } from '../../../../../common/constants';
import LoaderComponent from '../../../../../components/LoaderComponent';
import AllOrderCard from './AllOrderCard';

const AllOrderList = ({
  thresholdData = null,
  orderList,
  infiniteScrollRef,
  isFetchMoreOrderLoading,
  isEmptyOrderList,
  isOrderLoading,
  setOrder,
  isNewPath,
  setIsNotePrompts,
  setIsOrderAction,
  handleOrderChange,
  setIsAllOrderItemModalOpen,
  handleChallanDownload,
  isChallanLoading,
  handleChallanReset,
  isResetLoading,
  setVisible,
  setToyImages,
  showCheckBox,
  handleSelectOrders,
  selectedOrders,
  setIsReasonPrompt,
  isAdmin = false,
  isAssignDelPartnerTab,
  setDeliveryPartnerData,
  setIsDeliveryPartnerPrompts,
  isCombinedOrder = false,
  hasUpdatePermission,
  setIsAddCommentModalOpen,
  setIsOrderStatusModalOpen,
  playNotificationSound,
  criticalOrdersRef,
  isAllDelivery,
  isLibrary = false,
}) => (
  <div>
    {!isEmptyOrderList &&
      orderList?.map((order) => (
        <AllOrderCard
          thresholdData={thresholdData}
          key={order?.id}
          order={order}
          infiniteScrollRef={infiniteScrollRef}
          setOrder={setOrder}
          isNewPath={
            isCombinedOrder
              ? order?.status === ORDER_STATUS?.PLACED?.value ||
                order?.status === ORDER_STATUS?.CONFIRMED?.value
              : isNewPath
          }
          setIsNotePrompts={setIsNotePrompts}
          setIsOrderAction={setIsOrderAction}
          handleOrderChange={handleOrderChange}
          setIsAllOrderItemModalOpen={setIsAllOrderItemModalOpen}
          handleChallanDownload={handleChallanDownload}
          isChallanLoading={isChallanLoading}
          handleChallanReset={handleChallanReset}
          isResetLoading={isResetLoading}
          setVisible={setVisible}
          setToyImages={setToyImages}
          showCheckBox={showCheckBox}
          handleSelectOrders={handleSelectOrders}
          selectedOrders={selectedOrders}
          setIsReasonPrompt={setIsReasonPrompt}
          isAdmin={isAdmin}
          isAssignDelPartnerTab={isAssignDelPartnerTab}
          setDeliveryPartnerData={setDeliveryPartnerData}
          setIsDeliveryPartnerPrompts={setIsDeliveryPartnerPrompts}
          isCombinedOrder={isCombinedOrder}
          hasUpdatePermission={hasUpdatePermission}
          setIsAddCommentModalOpen={setIsAddCommentModalOpen}
          setIsOrderStatusModalOpen={setIsOrderStatusModalOpen}
          playNotificationSound={playNotificationSound}
          criticalOrdersRef={criticalOrdersRef}
          isAllDelivery={isAllDelivery}
          isLibrary={isLibrary}
        />
      ))}
    {(isFetchMoreOrderLoading || isOrderLoading) && (
      <LoaderComponent size="small" setHeight={10} />
    )}
    {isEmptyOrderList && <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />}
  </div>
);

export default AllOrderList;
